import {AUTH_TOKEN_KEY} from '../tools'
class Auth {
    constructor(){
    } 
    
    fetchUser(){
        if(!localStorage.getItem(AUTH_TOKEN_KEY)) {
            this.user = null
        } else {
            this.getUserFromLocalStorage()
        } 
    }

    logInUser(){
        this.getUserFromLocalStorage()
    }

    logOutUser(){
        localStorage.removeItem(AUTH_TOKEN_KEY)
        this.user = null
    }

    getUserFromLocalStorage() {
        this.user = {
            token: localStorage.getItem(AUTH_TOKEN_KEY)
        }
    }
}

export default new Auth()